@if (newsItem(); as n) {
  <a
    class="relative flex flex-row gap-2 rounded-2xl rounded-bl-md border border-neutral-16 bg-neutral-0 p-2 transition duration-300 ease-in-out hover:drop-shadow-lg"
    [href]="n.link"
    target="_blank">
    <img class="aspect-square h-40 w-40 rounded-2xl rounded-bl-md object-cover" [src]="n.imageSrc" [alt]="n.title" />
    <div class="flex flex-col gap-2 p-2">
      <span class="line-clamp-2 font-heading text-lg font-medium">{{ n.title }}</span>
      <span class="line-clamp-2 pr-4 text-sm text-neutral-80">{{ n.summary }}</span>
      <span class="text-sm text-neutral-60">{{ n.date | dateAgo }}</span>
    </div>
    <div class="absolute bottom-2 right-2 flex flex-col justify-end">
      <div class="rounded-xl rounded-bl-none bg-primary-base p-2 text-neutral-0">
        <pay-icon [size]="'md'" [shape]="IconNames.ChevronRight" />
      </div>
    </div>
  </a>
}
